import {
  EntityNameEnum,
  EventTypeEnum,
  IntegrationLogStatusEnum,
} from '@monetize/types/app';

export const EntityNameEnumDisplay: Record<EntityNameEnum, string> = {
  [EntityNameEnum.ACCOUNT]: 'Account',
  [EntityNameEnum.CONTRACT]: 'Contract',
  [EntityNameEnum.CREDIT]: 'Credit',
  [EntityNameEnum.CREDIT_NOTE]: 'Credit Note',
  [EntityNameEnum.INVOICE]: 'Invoice',
  [EntityNameEnum.PAYMENT]: 'Payment',
  [EntityNameEnum.QUOTE]: 'Quote',
  [EntityNameEnum.QUOTE_OFFERING]: 'Quote Offering',
  [EntityNameEnum.REFUND]: 'Refund',
};

export const EventTypeEnumDisplay: Record<EventTypeEnum, string> = {
  [EventTypeEnum.CREATE]: 'Create',
  [EventTypeEnum.UPDATE]: 'Update',
};

export const IntegrationStatusEnumDisplay: Record<
  IntegrationLogStatusEnum,
  string
> = {
  [IntegrationLogStatusEnum.FAILED]: 'Failed',
  [IntegrationLogStatusEnum.SUCCESS]: 'Successful',
};

export const TargetSystemTypeEnumDisplay: Record<string, string> = {
  salesforce: 'Salesforce',
  hubspot: 'HubSpot',
  attio: 'Attio',
  xero: 'Xero',
  quickbooks: 'QuickBooks',
  netsuite: 'NetSuite',
  rillet: 'Rillet',
};

export const IntegrationLogStatusTagStyle: {
  [key in IntegrationLogStatusEnum]: {
    color: string;
    bgColor?: string;
    px?: number;
    borderRadius?: number;
    fontStyle?: string;
  };
} = {
  Successful: {
    color: 'tGreen.approval',
    bgColor: 'tGreen.light',
    px: 2,
    borderRadius: 4,
  },
  Failed: {
    color: 'tRed.base',
    bgColor: 'tRed.cosmos',
    px: 2,
    borderRadius: 4,
  },
};
